module.exports = __webpack_public_path__ + "img/detail.cff5521d.svg";